module.exports = "<p>\n  seller-account-transactions works!\n</p>\n"